var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.route,"custom":""},scopedSlots:_vm._u([{key:"default",fn:function({ href, navigate, isActive, isExactActive }){return [_c('a',{directives:[{name:"tip",rawName:"v-tip",value:({ content: _vm.tip }),expression:"{ content: tip }"}],staticClass:"relative group w-full flex items-center pl-8 pr-3 py-2 text-sm font-medium hover:text-white rounded-r",class:[
      (_vm.exact ? isExactActive : isActive)
        ? 'text-white bg-blue-600 bg-opacity-25'
        : 'text-gray-300 hover:bg-blue-600 hover:bg-opacity-25',
    ],attrs:{"href":href},on:{"click":navigate}},[_c('div',{staticClass:"absolute left-4 h-full w-px border-l",class:[
        (_vm.exact ? isExactActive : isActive)
          ? 'border-blue-300'
          : 'border-gray-700 group-hover:border-blue-300',
      ]}),_c('div',[_vm._v(" "+_vm._s(_vm.label)+" ")])])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }